import styled from "styled-components"

export default {
    "Label": styled.p`
        width: 100%;
        ${({ theme }) => theme.font["medium-medium"]};
        text-align: center;
        padding-top: 8px;
    `
}